import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c14eb5c4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-10 col-lg-4 p-3 bg-light custom-modal m-auto rounded-3 mt-5" }
const _hoisted_2 = { class: "row pt-3" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "Vous avez un document médical à charger? 🩺")
], -1))
const _hoisted_4 = { class: "col-1" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "material-icons-outlined" }, " close ", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row m-2 pt-3" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col bg-primary text-start text-light rounded pt-3 mx-3" }, [
    /*#__PURE__*/_createElementVNode("p", null, [
      /*#__PURE__*/_createElementVNode("ul", null, [
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("u", null, "Si vous participez à la course à pied"),
          /*#__PURE__*/_createTextVNode(" : Le document médical requis est une attestation de Parcours Prévention Santé. Ce document a une durée de "),
          /*#__PURE__*/_createElementVNode("strong", null, "validité de trois mois"),
          /*#__PURE__*/_createTextVNode(". Au-delà de ces trois mois, le document ne sera pas accepté.")
        ]),
        /*#__PURE__*/_createElementVNode("li", null, [
          /*#__PURE__*/_createElementVNode("u", null, "Si vous participez aux autres épreuves"),
          /*#__PURE__*/_createTextVNode(" : Le document médical requis est un certificat médical. Il doit dater de "),
          /*#__PURE__*/_createElementVNode("strong", null, "moins d'un an"),
          /*#__PURE__*/_createTextVNode(" au moment de la compétition et doit comporter l'autorisation de la pratique des disciplines en compétition selon votre course. Les licences des fédérations correspondant aux courses sont acceptées (FFC pour le vélo par exemple). ")
        ])
      ])
    ])
  ])
], -1))
const _hoisted_8 = { class: "row m-2 pt-3" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col bg-warning text-start rounded pt-3 mx-3" }, [
  /*#__PURE__*/_createElementVNode("p", null, [
    /*#__PURE__*/_createElementVNode("strong", null, [
      /*#__PURE__*/_createElementVNode("u", null, "Attention: ")
    ]),
    /*#__PURE__*/_createTextVNode(" Pour les athlètes mineurs, une autorisation doit être signée par le responsable légal de l'athlète. Il faut charger l'autorisation parentale à la suite du document médical, "),
    /*#__PURE__*/_createElementVNode("strong", null, "dans le même fichier"),
    /*#__PURE__*/_createTextVNode(". Un modèle d'autorisation parentale est fourni dans "),
    /*#__PURE__*/_createElementVNode("a", {
      href: "https://links.24heures.org/reglement-courses",
      target: "_blank"
    }, "le règlement intérieur des courses"),
    /*#__PURE__*/_createTextVNode(", à l'Annexe 1. ")
  ])
], -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = { class: "row m-2 pt-3" }
const _hoisted_12 = { class: "col text-start fw-bold" }
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"row\" data-v-c14eb5c4><div class=\"col form-group\" data-v-c14eb5c4><label for=\"inputCertificate\" data-v-c14eb5c4>Document:</label><input type=\"file\" class=\"form-control\" id=\"inputCertificate\" name=\"certificate\" accept=\"image/png, image/jpeg,.pdf\" data-v-c14eb5c4></div></div><div class=\"row mt-5\" data-v-c14eb5c4><div class=\"col-12 text-center\" data-v-c14eb5c4><button type=\"submit\" class=\"btn btn-primary\" data-v-c14eb5c4>Envoyer</button></div></div>", 2)
const _hoisted_15 = [
  _hoisted_13
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "backdrop overflow-scroll",
    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            id: "close-arrow",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeModal && _ctx.closeModal(...args)))
          }, _hoisted_6)
        ])
      ]),
      _hoisted_7,
      _withDirectives(_createElementVNode("div", _hoisted_8, _hoisted_10, 512), [
        [_vShow, _ctx.isAthleteMinor(_ctx.birthDate)]
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("form", {
            onSubmit: _cache[1] || (_cache[1] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.uploadCertificate && _ctx.uploadCertificate(...args)), ["prevent"]))
          }, _hoisted_15, 32)
        ])
      ])
    ])
  ]))
}